import React from 'react';
import { Link } from 'react-scroll';

const HomeModalMenu = ( props ) => {
    return (
        <nav className="menu-primary">
            <ul className="nav flex-column">
                <li id="nav-about" className="nav-item">
                    <Link onClick={ props.action } title="About Us" to="about-us" href="#about-us" smooth={true} duration={700}>About Us</Link>
                </li>

                <li id="nav-appointments" className="nav-item">
                    <Link onClick={ props.action} title="Appointments" to="appointments" href="#appointments" smooth={true} duration={700}>Appointments</Link>
                </li>

                <li id="nav-treatments" className="nav-item">
                    <Link onClick={ props.action } title="Treatments" to="treatments" href="#treatments" smooth={true} duration={700}>Treatments</Link>
                </li>

                <li id="nav-teams" className="nav-item">
                    <Link onClick={ props.action } title="Physiotherapist" to="our-team" href="#our-team" smooth={true} duration={700}>Physiotherapist</Link>
                </li>

                <li id="nav-contact-us" className="nav-item">
                    <Link onClick={ props.action } title="Contact Us" to="contact-us" href="#contact-us" smooth={true} duration={700}>Contact Us</Link>
                </li>
            </ul>
        </nav>
    );
};

export default HomeModalMenu;
